<template lang="pug">
.v-field-range.field-range(v-if="field" :class="{'disabled': field.disabled}")
	.field-range__label(v-if="field.text") {{field.text}}
	input.field-range__value(type="number" v-model="inputValue" @input="handleInput" @blur="handleInputBlur" :disabled="field.disabled")
	.field-range__currency(v-if="field.currency")
		img.field-range__currency-image(:src="field.currency.image")
		span.field-range__currency-text {{field.currency.text}}
	.field-range__range-area
		.field-range__progress(:style="{'width': (localValue - field.min) * 100 / (field.max - field.min) + '%'}")
		input.field-range__input(type="range" v-model="localValue" :min="field.min" :max="field.max" @input="handleRangeInput" :disabled="field.disabled")
</template>

<script>
export default {
	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		modelValue: {
			type: Number,
			default: null
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			localValue: null,
			debounceTimeout: null,
			inputValue: this.modelValue
		};
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		},

		localValue() {
			this.inputValue = this.localValue;
		}
	},

	created() {
		this.updateLocalValue();
	},

	methods: {
		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		handleRangeInput() {
			clearTimeout(this.debounceTimeout);
			this.debounceTimeout = setTimeout(this.emitInput, 20);
		},

		handleInput() {
			if (this.validValue(this.inputValue)) {
				this.localValue = this.inputValue;
				this.emitInput()
			}
		},

		handleInputBlur() {
			if (this.field?.min > this.inputValue) {
				this.inputValue = this.field?.min;
				this.localValue = this.inputValue;
				this.emitInput();
			}
			if (this.field?.max < this.inputValue) {
				this.inputValue = this.field?.max;
				this.localValue = this.inputValue;
				this.emitInput();
			}
		},

		validValue(value) {
			return this.field?.min <= value && this.field?.max >= value;
		},

		emitInput() {
			if (this.field.disabled) return
			clearTimeout(this.debounceTimeout);
			this.$emit('update:model-value', +this.localValue);
		}
	}
};
</script>
